import React, { memo } from 'react'
import { Grid } from '@mui/material'

import Text from '../shared/text/Text'
import CustomTooltip from '../shared/customTooltip/CustomTooltip'
import PopoverHelpText from '../shared/popoverHelpText/PopoverHelpText'
import HeadingWithHelpText from '../shared/text/HeadingWithHelpText'

const DisplayStats = ({
  data,
  reverseTitle,
  descStyles,
  gridSize = 4,
  gridProps
}) => {
  return (
    <Grid container spacing={3} {...gridProps}>
      {data.map(
        (
          {
            label,
            value,
            hoverText,
            desc,
            helpText,
            descHelpText,
            subDesc,
            dataDescStyles
          },
          index
        ) => {
          const title = (
            <HeadingWithHelpText label={label} helpText={helpText} />
          )
          const description = (
            <>
              {value && (
                <CustomTooltip label={hoverText}>
                  <Text
                    variant='h2'
                    color='primary.main'
                    label={value}
                    fontWeight={700}
                    component='span'
                    {...descStyles}
                    {...dataDescStyles}
                  />
                </CustomTooltip>
              )}
              {subDesc}
            </>
          )
          return (
            <Grid item key={index} xs={12} sm={gridSize}>
              {reverseTitle ? description : title}
              {reverseTitle ? title : description}
              {desc && (
                <Text
                  variant='h6'
                  label={
                    <>
                      {desc}{' '}
                      {descHelpText && <PopoverHelpText label={descHelpText} />}
                    </>
                  }
                  fontWeight={500}
                  color='text.secondary'
                />
              )}
            </Grid>
          )
        }
      )}
    </Grid>
  )
}

export default memo(DisplayStats)
